import { render, staticRenderFns } from "./profitableListDetail.vue?vue&type=template&id=3042c7fc&scoped=true"
import script from "./profitableListDetail.vue?vue&type=script&lang=js"
export * from "./profitableListDetail.vue?vue&type=script&lang=js"
import style0 from "./profitableListDetail.vue?vue&type=style&index=0&id=3042c7fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3042c7fc",
  null
  
)

export default component.exports